import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import {RoutingService} from '../../services';


@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss']
})
export class EventsPageComponent implements OnInit {
    travels: any;
    currentDate: any;
    selectedDate: any;
    days: any[];
    events: any[];
    selectedEvent: any;
    isLoaded: boolean;

    public Editor = ClassicEditor;

    constructor(
        private routingService: RoutingService,
    ){}

    ngOnInit() {
        this.currentDate = moment();

        if (this.routingService.params.event) {
            this.selectedEvent = {...this.routingService.params.event, isOpened: true}
        }

        this.isLoaded = true;

    }

    openItem(event: any) {
        event.isOpened = !event.isOpened;
    }


    onSelectedDateChange(day: any) {
        this.selectedDate = day.dayFullDate.clone();
        this.events = day.dayEvents;
    }


}
